import { ComponentCategory, PropType, type ComponentMeta } from "@mijalowcode/types";

export const ButtonMeta: ComponentMeta = {
  componentName: "Button",
  package: "@mijadesign/mjui-react",
  title: "按钮",
  category: ComponentCategory.GENERAL,
  visibleInComponentPanel: true,
  npm: {
    package: "@mijadesign/mjui-react",
    exportName: "Button",
  },
  docLinks: [
    {
      title: "移动端组件库 Button",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mobile/doc",
      source: "mijadesign",
    },
  ],
  eventSources: [
    {
      name: "click",
      label: "点击",
      trigger: "dom",
    },
  ],
  props: [
    {
      name: "text",
      label: "按钮文案",
      type: PropType.STRING,
      defaultValue: "按钮",
    },
    {
      name: "type",
      label: "按钮类型",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "主按钮", value: "primary" },
        { label: "默认", value: "default" },
        { label: "信息", value: "info" },
        { label: "警告", value: "warning" },
        { label: "危险", value: "danger" },
        { label: "成功", value: "success" },
      ],
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "large",
      options: [
        { label: "大", value: "large" },
        { label: "常规", value: "normal" },
        { label: "小", value: "small" },
        { label: "迷你", value: "mini" },
      ],
    },
    {
      name: "shape",
      label: "形状",
      type: PropType.ENUM,
      defaultValue: "round",
      options: [
        { label: "圆角", value: "round" },
        { label: "默认", value: "default" },
        { label: "方形", value: "square" },
      ],
    },
    {
      name: "block",
      label: "块级按钮",
      type: PropType.BOOLEAN,
      defaultValue: true,
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
    },
    {
      name: "loading",
      label: "加载中",
      type: PropType.BOOLEAN,
      defaultValue: false,
    },
  ],
  defaultProps: {
    text: "按钮",
    type: "default",
    size: "large",
    shape: "round",
    block: true,
    disabled: false,
    loading: false,
  },
  snippet: {
    componentName: "Button",
    package: "@mijadesign/mjui-react",
    props: {
      text: "按钮",
      type: "default",
      size: "large",
      shape: "round",
      block: true,
      disabled: false,
      loading: false,
    },
  },
};
